<div class="timeline"
    [ngClass]="{'timeline-fullscreen': intersecting}"
    rootMargin="0px"
    [threshold]="threshold"
    [intersectionEnabled]="enableParallax"
    (finderIntersection)="setIntersection($event)">
    <div class="timeline-block"
        *ngFor="let block of timelineData.blocks"
        rootMargin="25% 0px 0px"
        threshold="0.5"
        [ngClass]="block.blockClasses"
        [intersectionEnabled]="enableParallax"
        (finderIntersection)="block.intersecting = $event.isIntersecting">
        <ng-container *ngFor="let lottie of block.media?.lottie">
            @defer {
                <finder-lottie class="timeline-lottie"
                    [data]="lottie"
                    [ngClass]="{'active': block.intersecting}">
                </finder-lottie>
            }
        </ng-container>
        <ng-container *ngFor="let picture of block.media?.picture">
            <finder-picture class="timeline-image"
                [picture]="picture"
                [ngClass]="{'active': block.intersecting}">
            </finder-picture>
        </ng-container>
        <div class="timeline-overlay" *ngIf="block.overlay" [ngClass]="[block.overlay.lineStyle]">
            <finder-font-icon class="overlay-icon" [ngClass]="[block.overlay.iconStyle]" [hexValue]="block.overlay.icon"
                size="l">
            </finder-font-icon>
        </div>
        <div class="timeline-content" *ngIf="block.content"
            [ngClass]="[block.content.mobileTextAlignment, block.content.textAlignment, block.content.textPosition, block.content.textStyle]">
            <h2 class="title" [innerHTML]="block.content.title | safeHtml"></h2>
            <p class="subtitle" *ngIf="block.content.subtitle" [innerHTML]="block.content.subtitle | safeHtml"></p>
            <div class="links" *ngIf="block.content.links && block.content.links.length > 0">
                <finder-anchor class="disable-text-decoration" *ngFor="let link of block.content.links" [href]="link.href">
                    <div class="link">
                        <span [innerHTML]="link.title"></span>
                        <finder-font-icon class="link-icon" [hexValue]="link.icon" size="s"></finder-font-icon>
                    </div>
                </finder-anchor>
            </div>
        </div>
    </div>
</div>
